import React from 'react';

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

export interface IconSquigglyProps extends Omit<SvgIconProps, 'color'> {
  color?: string;
}

const IconSquiggly: React.FC<IconSquigglyProps> = ({ color = '', ...rest }) => (
  <SvgIcon viewBox="0 0 17 15" {...rest}>
    <path
      d="M4.29395 14.0001C2.46663 13.5279 1.53485 12.4525 1.49861 10.7737V9.24996C1.49861 8.17689 0.999076 7.64036 0 7.64036V6.36698C0.999076 6.36698 1.49861 5.82806 1.49861 4.75022V3.23361C1.51414 2.37516 1.75485 1.68124 2.22074 1.15185C2.69181 0.622473 3.38288 0.238552 4.29395 9.15527e-05L4.66667 1.00162C3.77112 1.2687 3.30782 1.99839 3.27676 3.19069V4.73591C3.27676 5.80898 2.82899 6.56252 1.93344 6.99651C2.82899 7.43528 3.27676 8.19597 3.27676 9.27858V10.8023C3.30782 11.9946 3.77112 12.7243 4.66667 12.9914L4.29395 14.0001Z"
      fill={color}
    />
    <path
      d="M11.5726 14.0001C13.3999 13.5279 14.3317 12.4525 14.368 10.7737V9.24996C14.368 8.17689 14.8675 7.64036 15.8666 7.64036V6.36698C14.8675 6.36698 14.368 5.82806 14.368 4.75022V3.23361C14.3524 2.37516 14.1117 1.68124 13.6458 1.15185C13.1748 0.622473 12.4837 0.238552 11.5726 9.15527e-05L11.1999 1.00162C12.0955 1.2687 12.5588 1.99839 12.5898 3.19069V4.73591C12.5898 5.80898 13.0376 6.56252 13.9331 6.99651C13.0376 7.43528 12.5898 8.19597 12.5898 9.27858V10.8023C12.5588 11.9946 12.0955 12.7243 11.1999 12.9914L11.5726 14.0001Z"
      fill={color}
    />
    <path
      d="M7.94429 6.11586L8.9396 4.34946H10.6294L8.94507 7.24789L10.7005 10.2666H9.00522L7.94976 8.40727L6.89976 10.2666H5.19897L6.95444 7.24789L5.27554 4.34946H6.97085L7.94429 6.11586Z"
      fill={color}
    />
  </SvgIcon>
);

export default IconSquiggly;
